import { StyleSheet } from '../lib/react-native-compat';

// Color palette
const colors = {
    border: '#d1d5db',          // clean gray border
    borderLight: '#e5e7eb',     // lighter border for inner cells
    headerBg: '#f3f4f6',        // header cell background
    headerBgAlt: '#eef2ff',     // blue-tinted header for sections
    cellBg: '#ffffff',          // default cell background
    cellBgPast: '#f9fafb',      // past-week cells
    text: '#1f2937',            // primary text
    textSecondary: '#6b7280',   // secondary/label text
    textMuted: '#9ca3af',       // muted text
    accent: '#1e40af',          // blue accent
    accentLight: '#dbeafe',     // light blue tint
    separator: '#e5e7eb',       // row separators
    focus: '#3b82f6',           // focus/edit indicator
    sectionBg: '#f8fafc',       // section background
}

const s = StyleSheet.create({
    // Week column cell
    rate: {
        width: 60,
        height: 26,
        borderBottom: `1px solid ${colors.borderLight}`,
        borderRight: `1px solid ${colors.borderLight}`,
        padding: 3,
        textAlign: 'center',
        fontSize: 11,
        color: colors.text,
        justifyContent: 'center',
    },
    // Week column date header
    // week date header cell: "2026-05-11" on one line in a 60 px cell (Geist runs
    // wider than the old face, so it is a step smaller with no side padding)
    rateC: {
        width: 60,
        height: 18,
        padding: '2px 0',
        fontSize: 8,
        letterSpacing: -0.2,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textAlign: 'center',
        color: colors.textSecondary,
        fontWeight: '500',
        fontVariantNumeric: 'tabular-nums',
    },
    // blank week cell
    rateB: {
        width: 60,
        height: 26,
        padding: 2,
    },
    // Label cell (phase row left side)
    span: {
        width: 75,
        padding: 3,
        height: 26,
        alignItems: 'center',
        textAlign: 'right',
        fontSize: 11,
        color: colors.text,
    },
    // Top-level label cell
    spanTop: {
        width: 78,
        padding: 3,
        height: 26,
        alignItems: 'center',
        textAlign: 'right',
        fontSize: 11,
        color: colors.text,
        borderBottom: `1px solid ${colors.borderLight}`,
    },
    // Wider label
    spanS: {
        width: 90,
        padding: 3,
        height: 26,
        alignItems: 'center',
        textAlign: 'right',
        fontSize: 11,
        color: colors.text,
    },
    // Compact label
    spanSC: {
        width: 75,
        padding: 3,
        height: 18,
        alignItems: 'center',
        textAlign: 'right',
        fontSize: 11,
    },
    // Spacer
    break: {
        width: 0,
        padding: 2,
        height: 26,
    },
    // Summary table cell
    total: {
        width: 62,
        maxWidth: 62,
        overflow: 'hidden',
        borderBottom: `1px solid ${colors.border}`,
        borderRight: `1px solid ${colors.border}`,
        textAlign: 'right',
        padding: 3,
        minHeight: 24,
        fontSize: 11,
        color: colors.text,
    },
    // Small text in total cells
    totalS: {
        fontSize: 9,
        color: colors.textSecondary,
    },
    // Wider total cell (date inputs)
    totalH: {
        width: 84,
        borderBottom: `1px solid ${colors.border}`,
        borderRight: `1px solid ${colors.border}`,
        textAlign: 'right',
        padding: 3,
        fontSize: 11,
        color: colors.text,
    },
})

// Shared inline style helpers
const headerCell = {
    backgroundColor: colors.headerBg,
    fontWeight: '600',
    fontSize: 10,
    color: colors.textSecondary,
}

const valueCell = {
    backgroundColor: colors.cellBg,
}

const valueCellAlt = {
    backgroundColor: colors.sectionBg,
}

const pastWeekCell = {
    backgroundColor: colors.cellBgPast,
}

const weekDateHeader = {
    backgroundColor: '#f8fafc',
    paddingBottom: 4,
    borderBottom: `2px solid ${colors.border}`,
    height: 24,
    fontWeight: '600',
}

const stickyHeader = {
    backgroundColor: 'white',
    borderRadius: 8,
    flexDirection: 'row',
    padding: 16,
    paddingBottom: 12,
    border: `1px solid ${colors.borderLight}`,
    boxShadow: '0 1px 3px rgba(0,0,0,0.04), 0 1px 2px rgba(0,0,0,0.06)',
}

const phaseCard = {
    backgroundColor: 'white',
    borderRadius: 8,
    flexDirection: 'row',
    padding: 16,
    paddingTop: 10,
    marginBottom: 2,
    border: `1px solid ${colors.borderLight}`,
    boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
}

const expandButton = {
    backgroundColor: colors.headerBg,
    width: 28,
    marginTop: 24,
    justifyContent: 'center',
    borderRadius: 4,
    border: `1px solid ${colors.borderLight}`,
}

const sectionDivider = {
    width: '100%',
    height: 12,
    backgroundColor: colors.separator,
    borderRadius: 2,
}

const phaseCollapseHeader = (isCollapsed) => ({
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 6,
    paddingHorizontal: 12,
    backgroundColor: isCollapsed ? '#f8fafc' : '#eef2ff',
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    borderBottomLeftRadius: isCollapsed ? 8 : 0,
    borderBottomRightRadius: isCollapsed ? 8 : 0,
    borderTop: `1px solid ${colors.borderLight}`,
    borderLeft: `1px solid ${colors.borderLight}`,
    borderRight: `1px solid ${colors.borderLight}`,
    borderBottom: isCollapsed ? `1px solid ${colors.borderLight}` : 'none',
    marginTop: 8,
})

const editIndicator = {
    width: 3,
    height: 18,
    backgroundColor: colors.focus,
    borderRadius: 2,
    left: 3,
    top: 4,
    position: 'absolute',
}

export { s, colors, headerCell, valueCell, valueCellAlt, pastWeekCell, weekDateHeader, stickyHeader, phaseCard, expandButton, sectionDivider, phaseCollapseHeader, editIndicator }
export default s
